<!-- Since this label is defined outside the form field, we are responsible for matching its colors to the form control state. -->
@if (externalLabel) {
  <mat-label class="text-label-large" [class.uppercase]="uppercaseExternalLabel" [class.text-error]="styleExternalLabelAsError"
             [class.text-primary]="styleExternalLabelAsFocused">
    {{ label }}
  </mat-label>
}

<mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="w-full" [ngClass]="{ 'mx-external-label': externalLabel }"
                [hintLabel]="hintLabel" [hideRequiredMarker]="!enabled">
  @if (!externalLabel) {
    <mat-label>
      {{ label }}
    </mat-label>
  }

  <ng-content/>

  @if (showValidationErrors) {
    <mat-error>
      <mx-field-error fieldLabel="{{ label }}" [field]="control"/>
    </mat-error>
  }
</mat-form-field>
